module.exports = __webpack_public_path__ + "static/media/hero-0.06805f49.png";